import { Reservation, PaginatedResponse } from '../types';
import apiService from './api';

export class ReservationService {
  async getAllReservations(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<Reservation>> {
    return apiService.getPaginated<Reservation>(
      '/api/operations/admin/all',
      page,
      size,
      sort,
      filters
    );
  }

  async getReservationById(id: string): Promise<Reservation> {
    return apiService.get<Reservation>(`/api/operations/${id}`);
  }

  async updateReservationStatus(id: string, status: string): Promise<void> {
    await apiService.put(`/api/operations/${id}/status`, { status });
  }

  async getReservationStats(): Promise<any> {
    return apiService.get('/api/operations/stats');
  }

  async createReservation(reservationData: Partial<Reservation>): Promise<Reservation> {
    return apiService.post<Reservation>('/api/operations', reservationData);
  }
}

export const reservationService = new ReservationService();
export default reservationService;
